export default {
  eyebrow: 'Portail partenaire',
  title: 'Image de marque',
  description: "L'apparence de votre portail en marque blanche et de votre page de connexion.",
  page: {
    read_only_notice: 'Lecture seule. Cliquez sur Modifier pour changer une valeur.',
    editing_notice: 'Modification — les changements sont visibles par votre équipe et vos clients.',
  },
  branding: {
    scope_hint:
      "S'applique à votre portail en marque blanche et à votre page de connexion — pas aux vitrines de vos restaurants, qui ont une marque par restaurant.",
    upload: 'Télécharger le logo',
    logo: {
      label: 'Logo',
      hint: 'Affiché sur vos surfaces en marque blanche.',
    },
    circle_logo: {
      label: 'Favicon / logo circulaire',
      hint: 'Logo carré utilisé comme favicon et avatar. Facultatif — peut être supprimé.',
    },
    splash_image: {
      label: 'Image de connexion',
      hint: 'Affichée sur votre page de connexion en marque blanche. Recommandé : au moins 1200 px de large. Facultatif — peut être supprimée.',
    },
    footer_note: "D'autres options de personnalisation (couleurs secondaires) arrivent prochainement.",
  },
  form: {
    primary_color: {
      label: 'Couleur principale de la marque',
      hint: 'Personnalise votre portail partenaire et votre page de connexion.',
    },
    dashboard_subdomain: {
      label: 'Slug de connexion partenaire',
      hint: "Slug en minuscules — identifie votre marque dans le lien de connexion de l'équipe (?partner=…).",
      placeholder: 'nom-partenaire',
    },
    login_url: {
      label: "Lien de connexion de l'équipe",
      hint: 'Partagez ce lien avec votre équipe — il ouvre la page de connexion avec votre image de marque.',
    },
    file: {
      label: 'Image',
    },
  },
  login_url_warning: {
    title: 'Modifier le lien de connexion de votre équipe ?',
    description:
      "Votre lien de connexion de l'équipe sera remplacé par {{url}}. Partagez le nouveau lien désormais — l'ancien n'affichera plus votre marque.",
    description_no_url:
      "Votre lien de connexion de l'équipe va changer. Partagez le nouveau lien désormais — l'ancien n'affichera plus votre marque.",
  },
  login_url_changed: {
    title: "Lien de connexion de l'équipe modifié",
    description:
      'Votre équipe se connecte désormais sur {{url}}. Enregistrez le nouveau lien en favori et partagez-le avec votre équipe.',
  },
  buttons: {
    edit: 'Modifier',
    cancel: 'Annuler',
    save: 'Enregistrer',
  },
  toasts: {
    load_error: 'Impossible de charger votre image de marque.',
    failed_to_save_changes: "Échec de l'enregistrement des modifications",
    changes_got_saved: 'Modifications enregistrées',
    logo_uploaded: 'Logo téléchargé',
    logo_upload_failed: 'Échec du téléchargement du logo',
    logo_removed: 'Logo supprimé',
    logo_remove_failed: 'Échec de la suppression du logo',
    file_too_large: 'Fichier trop volumineux. La taille maximale est de {{max}} Mo.',
    image_too_narrow: "L'image de connexion doit faire au moins {{min}} px de large.",
  },
};
